import React, { createContext, useContext } from "react";

interface FormContextState {
	formIsDisabled: boolean;
	formIsLiteral: boolean;
}

const defaultContext: FormContextState = {
	formIsDisabled: false,
	formIsLiteral: false
};

const Context = createContext<FormContextState>(defaultContext);
Context.displayName = "FormState";

export const FormProvider = Context.Provider;

export function useFormState() {
	return useContext(Context);
}

interface FormStateProviderProps {
	initialState: FormContextState;
	children: React.ReactNode;
}

export function FormStateProvider({
	initialState,
	children
}: FormStateProviderProps) {
	return <FormProvider value={initialState}>{children}</FormProvider>;
}
